import {
  createContext,
  Dispatch,
  ReactNode,
  SetStateAction,
  useContext,
  useState
} from "react"
import { TestDataVersionResponseType } from "../api/responseBuilders/testData"

interface TestDataContextProps {
  currentSelectedTestDataVersion: TestDataVersionResponseType | null
  setCurrentSelectedTestDataVersion: Dispatch<
    SetStateAction<TestDataVersionResponseType | null>
  >
}

const TestDataContext = createContext<TestDataContextProps | null>(null)

function TestDataProvider({ children }: { children: ReactNode }) {
  const [currentSelectedTestDataVersion, setCurrentSelectedTestDataVersion] =
    useState<TestDataVersionResponseType | null>(null)

  return (
    <TestDataContext.Provider
      value={{
        currentSelectedTestDataVersion,
        setCurrentSelectedTestDataVersion
      }}
    >
      {children}
    </TestDataContext.Provider>
  )
}

export const useTestDataContext = () => {
  const context = useContext(TestDataContext)
  if (!context) {
    throw new Error(
      "useTestDataContext must be used within an TestDataProvider"
    )
  }
  return context
}

export { TestDataContext, TestDataProvider }
